import { render } from "./OfferingInvestments.vue?vue&type=template&id=674e9e0e"
import script from "./OfferingInvestments.vue?vue&type=script&lang=js"
export * from "./OfferingInvestments.vue?vue&type=script&lang=js"
script.render = render

export default script